// Ventuz Config Helper Functions

import { deluge } from '@/stores/deluge.js';
import { $http } from '../stores/http';

import { clientNotification } from './notify';

// Types for JSDoc

/**
 * @typedef { import("vue").Ref } Ref
 */

export async function getGPUInfo() {
  // const response = await $http('GET', '/dynamic_engine/hardware/gpus');

  try {
    const response = await $http('GET', '/read_gpu_info');
    const data = JSON.parse(response);
    return data;
  } catch (error) {
    return error;
  }
}

export async function getListOfConfigs() {
  const data = await $http('GET', `/dynamic_engine/device_config/all`);
  return JSON.parse(data);
}

/**
 * @param {string} name - Name of the config to create.
 */
export async function createConfig(name) {
  const data = await $http(
    'POST',
    `/dynamic_engine/device_config/create?name=${name}`
  );
  return JSON.parse(data);
}

/**
 * @param {string} name - Name of the config to get.
 */
export async function getConfig(name) {
  const data = await $http(
    'GET',
    `/dynamic_engine/device_config/read?name=${name}`
  );
  const jsonData = JSON.parse(data);

  return jsonData;
}

/**
 * @param {string} name - Name of the config to change too.
 */
export async function setConfig(name) {
  const data = await $http(
    'GET',
    `/dynamic_engine/device_config/set?name=${name}`
  );
  return JSON.parse(data);
}

/**
 * @param {string} name - Name of the config to update.
 * @param {object} data - Keys and values of the data to update.
 */
export async function updateConfig(name, data) {
  const jsonString = JSON.stringify(data);
  const response = await $http(
    'POST',
    `/dynamic_engine/device_config/update?name=${name}`,
    jsonString
  );
  return JSON.parse(response);
}

/**
 * @param {string} name - Name of the config to delete.
 */
export async function deleteConfig(name) {
  const data = await $http(
    'DELETE',
    `/dynamic_engine/device_config/delete?name=${name}`
  );
  return JSON.parse(data);
}

export async function getCurrentConfigName() {
  const data = await $http('GET', '/dynamic_engine/device_config/current');
  return JSON.parse(data);
}

/**
 * @param {object} [ventuzDeviceConfig] - If not supplied returns 'Automatic'
 */
export function calcFPS(ventuzDeviceConfig) {
  if (!ventuzDeviceConfig.refreshNum && !ventuzDeviceConfig.refreshDen) {
    return 'Automatic';
  } else {
    return `${parseFloat(num / den).toPrecision(4)} fps`;
  }
}
